/* eslint-disable no-prototype-builtins */
import {
    SelectTextField,
    MultiSelectTextField,
    SelectNumberField,
    MultiSelectNumberField,
    MultiSelectizeText,
} from '../SelectField';
import { InputTextField, InputNumberField } from '../InputField';
import DatePicker from '../DateRange';
const ComponentsObj = {
    selecttext: SelectTextField,
    multiselecttext: MultiSelectTextField,
    selectnumber: SelectNumberField,
    multiselectnumber: MultiSelectNumberField,
    multiselectizetext: MultiSelectizeText,
    texttext: InputTextField,
    multitexttext: InputTextField,
    rangedate: DatePicker,
    textnumber: InputNumberField,
    multitextnumber: InputNumberField,
};

function getSpecificComponent(item) {
    const setMultiple = item.multiple ? 'multi' : '';
    const specificComponentType = `${setMultiple}${item.input}${item.type}`;
    return ComponentsObj.hasOwnProperty(specificComponentType)
        ? ComponentsObj[specificComponentType]
        : ComponentsObj.texttext;
}

export { ComponentsObj, getSpecificComponent };
